/**
 * Format number for financial display with Thai Baht symbol
 * - Right-aligned
 * - Comma separator for thousands
 * - 2 decimal places for currency
 */
export const formatCurrency = (value: number | undefined | null): string => {
  if (value === undefined || value === null) return '-'

  // Format with comma separator and 2 decimal places
  const formatted = new Intl.NumberFormat('th-TH', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(value)

  return `฿${formatted}`
}

/**
 * Format number for display without currency symbol
 * - Right-aligned
 * - Comma separator for thousands
 */
export const formatNumber = (value: number | undefined | null): string => {
  if (value === undefined || value === null) return '-'

  return new Intl.NumberFormat('th-TH', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(value)
}

/**
 * Format number for input display (without currency symbol)
 * Used in InputNumber components
 */
export const formatInputNumber = (value: number | undefined | null): string => {
  if (value === undefined || value === null) return ''

  return new Intl.NumberFormat('th-TH', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(value)
}
